"use client";

import React from "react";
import styles from "./index.module.css";
import {
  HOME_PRODUCTS_BY_KEY,
  PRICING_PAYG_ORDER,
  PRICING_SUBSCRIPTION_ORDER,
} from "@/components/Home/productData";
import { GetStartedButton } from "@/components/Home/common/GetStarted";

const Pricing = () => {
  const titleText = "Two ways to pay — pick what fits";
  const subtitleText =
    "Usage-based products bill per call. Platform products bill a flat monthly rate. Mix and match freely.";

  const models = [
    {
      badge: "Pay as you go",
      badgeClass: styles.badgePayg,
      heading: "Only pay for what you use",
      description:
        "Per-call billing for usage-based APIs. Costs scale with your traffic — nothing more.",
      highlight: "No monthly fees, no minimums",
      listLabel: "Usage-based APIs",
      products: PRICING_PAYG_ORDER,
      buttonText: "Start building",
      secureText: "🔒 Secure payment powered by Stripe",
    },
    {
      badge: "Monthly subscription",
      badgeClass: styles.badgeSubscription,
      heading: "One flat monthly rate",
      description:
        "Predictable billing for platform products. One subscription, all the capacity the plan includes.",
      highlight: "Cancel anytime, no contracts",
      listLabel: "Subscription products",
      products: PRICING_SUBSCRIPTION_ORDER,
      buttonText: "Choose a plan",
      secureText: "Cancel anytime · secure payment powered by Stripe",
    },
  ];

  return (
    <div className={styles.background}>
      <section className={styles.pricing}>
        <h2>{titleText}</h2>
        <p>{subtitleText}</p>
        <div className={styles.plans}>
          {models.map((model, i) => (
            <div className={`${styles.plan} ${styles.pro}`} key={i}>
              <div className={`${styles.proBadge} ${model.badgeClass}`}>
                {model.badge}
              </div>
              <h3>{model.heading}</h3>
              <p>{model.description}</p>
              <p className={styles.highlight}>
                <img src="/images/home/check-icon.svg" alt="" />
                {model.highlight}
              </p>
              <div className={styles.listLabel}>{model.listLabel}</div>
              <ul>
                {model.products.map((key) => (
                  <li key={key}>
                    <img src="/images/home/check-icon.svg" alt="check icon" />
                    <p>{HOME_PRODUCTS_BY_KEY[key].name}</p>
                  </li>
                ))}
              </ul>
              <GetStartedButton
                style={{ fontSize: "16px", fontWeight: 600 }}
              >
                {model.buttonText}
              </GetStartedButton>
              <p className={styles.secure}>{model.secureText}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Pricing;
